<template>
	<div class="col-md-12 p-l-r-0 f-left">

		<div class="col-md-12 p-l-r-0 f-left nospace form-group">
			<label class="full_width-label">Please mention the names of partners who will act as Designated Partners*</label>
			<div class=" col-md-6 p-l-r-0 f-left">
				
				<input type="text" class="form-control" id="Partners_Option2" placeholder="Option 1" v-model="other_documents.designated_partners_name_option1">
				<span class="text-danger" v-if="other_validation.designated_partners_name_option1">Please enter designated partners name option1</span>
	        </div>
	        <div class="col-md-6 p-r-0 f-left" style="padding-right: 0px;">
				<input type="text" class="form-control" id="Partners_Option1" placeholder="Option 2" v-model="other_documents.designated_partners_name_option2">
				<span class="text-danger" v-if="other_validation.designated_partners_name_option2">Please enter  designated partners name option2</span>
	        </div>
	        <div class=" col-md-12 p-l-r-0 p-r-0 f-left">
	            <span class="teptext">    Any 2 of the partners can be nominated as Designated Partners. This does not have anything to do with contributions. </span>
	        </div>
			
		</div>
		<div class="col-md-12 p-l-r-0 f-left">
			<div class="form-group col-md-6 p-l-r-0 f-left">
				<label for="Website">Website (if available)</label>
    			<input type="text" class="form-control" id="Website" v-model="other_documents.website" >
            </div>
		</div>
		<div class="col-md-12 p-l-r-0 f-left">
			<div class="form-group col-md-12 p-l-r-0 p-r-0 nospace f-left">
				<label for="Website">    Please add a brief note about your business objective.*</label>
    			<textarea class="form-control text-area" id="Website"  rows="4" v-model="other_documents.brief_note"></textarea>
				<span class="text-danger" v-if="other_validation.brief_note">Please enter Brief note  of business</span>
            </div>
		</div>
		<div class="col-md-12 p-l-r-0 f-left nospace form-group">
			<label class="full_width-label">    Proposed options for LLP name* </label>
			<div class=" col-md-6 p-l-r-0 f-left">
				
    			<input type="text" class="form-control" id="Option2" placeholder="Option 1" v-model="other_documents.llp_name_option1">
            </div>
            <div class="col-md-6 p-r-0 f-left" style="padding-right: 0px;">
    			<input type="text" class="form-control" id="Option1" placeholder="Option 2" v-model="other_documents.llp_name_option2">
            </div>
            <div class=" col-md-12 p-l-r-0 p-r-0 f-left">
	            <span class="teptext">    Please ensure the proposed LLP name is unique and contains the company objective for e.g., a marketing company should be named ABC Marketing Private Limited. Company name is subject to approval. </span>
	        </div>
			<span class="text-danger" v-if="other_validation.llp_name_option1">Please enter Brief note  of business</span>
		</div>
		<div class="col-md-12 p-l-r-0 f-left">
			<div class="form-group col-md-6 p-l-r-0 f-left">
				<label for="aCapital">Contribution*</label>
    			<input type="text" class="form-control" id="aCapital" placeholder="1000000" v-model="other_documents.contribution">
    			<span class="teptext">An extra fee will be levied on all contributions above 10 lakhs. Kindly note the stamp duty for contributions up to 10 lakhs is Rs.1000, all contributions above 10 Lacs will have Rs.500 added for every 5 lakh.</span>
				<span class="text-danger" v-if="other_validation.contribution">Please enter contribution</span>
            </div>
		</div>
		<bills_agreement :parentName ="'llpagreement'" :propdata="props_to_child" :owner_information="child_prop_data" @UpdateFilePath="UpdateFilePath" :other_validation="other_validation" />
		<div class="col-md-12 p-l-r-0 f-left "><br>
			<button type="button" class="btn btn-primary gobtn submit" @click="Submit()">Submit</button>
		</div>
	</div>
</template>
<script>


import company_info from "../services/company_info"
import bills_agreement from './bills_agreement';
export default {
    name:'other_llp_details',
	props: ["parentName","propdata","props_to_child"],
     watch:{
	    propdata: {
            handler: function () {
                this.UpdateChildPropData();
            },
            immediate: true
        },
    },
    components: {
    	bills_agreement
    },
    data() {
        return {
        	Documents: "",
			other_documents:[],
			 other_validation: {
            },
			child_prop_data:{
				registered_office:'',
				rental_url:'',
				any_utility_bill_url:'',
				noc:''
			}
        }
    },
    methods: {
		UpdateChildPropData(){
			this.other_documents=this.propdata
			this.child_prop_data.registered_office=this.propdata.registered_office
			this.child_prop_data.registered_office_doc_url=this.propdata.registered_office_doc_url
			this.child_prop_data.any_utility_bill_url=this.propdata.any_utility_bill_url
			this.child_prop_data.noc=this.propdata.noc
		},
		 UpdateFilePath(payload) {
            if (payload.src == 'noc') {
                this.other_documents.noc = payload.url;
            }
            if (payload.src == 'registered_office_doc_url') {
                this.other_documents.registered_office_doc_url = payload.url;
            }
            if (payload.src == 'any_utility_bill_url') {
                this.other_documents.any_utility_bill_url = payload.url;
            }
            if (payload.src == 'registered_office') {
                this.other_documents.registered_office = payload.url;
            }
        },
		Submit(){
			company_info.postOtherDetails(this.propdata)
						.then(response=>{
							if(response.data.status=='success'){
								this.$notify({
                                group: 'auth',
                                title:'',
                                type: 'success',
                                text: 'Details saved successfully',
								ignoreDuplicates:true
                            });
							}
							 this.$emit("other_update", {
								src: 'llp_others'
							});
						})
						.catch(error=>{
							console.log(error.response)
						if(error.response.status==422){
							this.$notify({
									group: 'auth',
									title:'',
									type: 'warn',
									text: 'Please fill all required fields',
									ignoreDuplicates:true
								});
								var err=error.response.data.status;
								var temp={};
								Object.keys(err).forEach((key) => {
									temp[key]=err[key][0]
								});
								this.other_validation=temp
						}
					})
		},
    	getDocuments(e){
			this.Documents = e.target.files[0].name;
		}
    }
};

</script>
